import firebase from 'firebase'

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyAC-DfgfXVdiXlJdsUmybp42NkFeeNJ8iU',
  authDomain: 'game-project-d33f1.firebaseapp.com',
  databaseURL: 'https://game-project-d33f1.firebaseio.com',
  projectId: 'game-project-d33f1',
  storageBucket: 'game-project-d33f1.appspot.com',
  messagingSenderId: '869698351104'
}
firebase.initializeApp(config)
export default firebase
export const database = firebase.database()
export const auth = firebase.auth()
export const storage = firebase.storage()



// WEBPACK FOOTER //
// ./src/firebase.js